"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ShuttleIcon = require("./ShuttleIcon");

var _ShuttleIcon2 = _interopRequireDefault(_ShuttleIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _ShuttleIcon2.default;